export default __webpack_public_path__ + "static/media/create-pharmacy.74ffd8bf.webp";